import request from "@/utils/request/index";

export enum Api {
  COUPONPAGE = "/couponsUser/queryPage",
  MORECOUPONPAGE = "/coupons/canGetByUserId",
  CLAIMCOUPON = "/couponsUser/getCoupons",
  ORDERQUERYPAGE = "/order/queryPageByUserId",
  USECOUPONALL = "/couponsUser/queryAvailable",
}

export const getCouponData = (data?: any, config?: axiosConfig) =>
  request.post(Api.COUPONPAGE, data, config);

export const getMoreCouponData = (data?: any, config?: axiosConfig) =>
  request.post(Api.MORECOUPONPAGE, data, config);

export const getUserCoupon = (data?: any, config?: axiosConfig) =>
  request.post(Api.CLAIMCOUPON, data, config);


export const getUserOrder = (data?: any, config?: axiosConfig) =>
  request.post(Api.ORDERQUERYPAGE, data, config);
  
export const useCoupons = (data?: any) =>
  request.get(Api.USECOUPONALL, data);

  